import React, { useEffect, useState } from "react";
import { fetchGroups, deleteGroup, fetchGroupById, fetchWordsByGroup, deleteWord } from "./adminSimilarWordsService";
import WordGroupForm from "./WordGroupForm";
import WordForm from "./WordForm";
import "../../blog/tongueTwister.css";

const BASE_ROOT = process.env.REACT_APP_BASE_URL_ROOT || "";
const toPublicImgSrc = (url) => {
  if (!url) return "";
  const pub = url.replace(/\/api(?:\/admin)?\/media-images\//, "/api/public/media-images/");
  const src = pub.startsWith("http") ? pub : `${BASE_ROOT}${pub}`;
  console.log("[AdminSimilarWordsPage] img raw:", url, "→ resolved:", src);
  return src;
};

const AdminSimilarWordsPage = () => {
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showGroupForm, setShowGroupForm] = useState(false);
  const [editingGroup, setEditingGroup] = useState(null);

  const [selectedGroup, setSelectedGroup] = useState(null);
  const [words, setWords] = useState([]);
  const [wordsLoading, setWordsLoading] = useState(false);
  const [showWordForm, setShowWordForm] = useState(false);
  const [editingWord, setEditingWord] = useState(null);
  const [search, setSearch] = useState("");

  useEffect(() => { loadGroups(); }, [search]);

  const loadGroups = async () => {
    setLoading(true);
    const res = await fetchGroups({ search: search || undefined });
    if (res.status === 200) {
      const list = Array.isArray(res.data) ? res.data : res.data?.data || [];
      setGroups(list);
    }
    setLoading(false);
  };

  const handleDeleteGroup = async (id, wordCount) => {
    if (wordCount > 0) { alert("Delete all words in this group first."); return; }
    if (!window.confirm("Delete this word group?")) return;
    const res = await deleteGroup(id);
    if (res.status === 200 || res.status === 204) { loadGroups(); if (selectedGroup?.id === id) setSelectedGroup(null); }
    else alert(res.message);
  };

  const openGroupDetail = async (group) => {
    setWordsLoading(true);
    const res = await fetchGroupById(group.id);
    if (res.status === 200 && res.data) {
      setSelectedGroup(res.data);
      if (res.data.words) { setWords(res.data.words); setWordsLoading(false); return; }
    }
    const wRes = await fetchWordsByGroup(group.id);
    if (wRes.status === 200) setWords(Array.isArray(wRes.data) ? wRes.data : wRes.data?.data || []);
    setWordsLoading(false);
  };

  const reloadWords = async () => {
    if (!selectedGroup) return;
    const wRes = await fetchWordsByGroup(selectedGroup.id);
    if (wRes.status === 200) setWords(Array.isArray(wRes.data) ? wRes.data : wRes.data?.data || []);
    loadGroups();
  };

  const handleDeleteWord = async (id) => {
    if (!window.confirm("Delete this word?")) return;
    const res = await deleteWord(id);
    if (res.status === 200 || res.status === 204) reloadWords();
    else alert(res.message);
  };

  const onGroupSaved = async (savedGroup) => {
    setShowGroupForm(false);
    setEditingGroup(null);
    await loadGroups();
    // If a new group was just created, auto-open its detail view
    if (savedGroup && !editingGroup) {
      await openGroupDetail(savedGroup);
    }
  };

  const onWordSaved = () => { setShowWordForm(false); setEditingWord(null); reloadWords(); };

  // ===== WORD DETAIL VIEW =====
  if (selectedGroup) return (
    <div className="admin-container">
      <button onClick={() => setSelectedGroup(null)} style={{ marginBottom: 16, background: "none", border: "none", color: "#019095", cursor: "pointer", fontWeight: 600 }}>← Back to Groups</button>
      <div className="admin-header">
        <h2>{selectedGroup.title}</h2>
        <button onClick={() => { console.log("[AdminSimilarWords] + Add Word clicked, setting showWordForm=true"); setEditingWord(null); setShowWordForm(true); }}>+ Add Word</button>
      </div>
      {selectedGroup.youtubeVideoLink && (
        <p style={{ color: "#888", fontSize: 13, marginBottom: 20 }}>
          Video: <a href={selectedGroup.youtubeVideoLink} target="_blank" rel="noreferrer" style={{ color: "#019095" }}>{selectedGroup.youtubeVideoLink}</a>
        </p>
      )}

      {console.log("[AdminSimilarWords] showWordForm:", showWordForm, "selectedGroup:", selectedGroup?.id)}
      {showWordForm && <WordForm word={editingWord} wordGroupId={selectedGroup.id} onSaved={onWordSaved} onCancel={() => setShowWordForm(false)} />}

      {wordsLoading ? <p>Loading...</p> : words.length === 0 ? (
        <div style={{ textAlign: "center", padding: "40px 20px", color: "#888" }}>
          <div style={{ fontSize: 36, marginBottom: 12 }}>📝</div>
          <p style={{ fontWeight: 600, marginBottom: 6 }}>No words yet</p>
          <p style={{ fontSize: 13, marginBottom: 20 }}>Click <strong>+ Add Word</strong> to add the first word to this group.</p>
        </div>
      ) : (
        <table className="announcement-table">
          <thead><tr><th>Image</th><th>Word</th><th>Pronunciation</th><th>Meaning</th><th>Order</th><th>Active</th><th>Actions</th></tr></thead>
          <tbody>
            {words.map((w) => (
              <tr key={w.id}>
                <td>
                  {w.imageUrl ? (
                    <img src={toPublicImgSrc(w.imageUrl)} alt="" style={{ width: 40, height: 40, objectFit: "contain", background: "#f5f5f5", borderRadius: 6, border: "1px solid #eee" }} />
                  ) : (
                    <div style={{ width: 40, height: 40, background: "#f5f5f5", borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, color: "#bbb" }}>—</div>
                  )}
                </td>
                <td>
                  <strong>{w.word}</strong>
                  {w.vocabularyId && <span style={{ marginLeft: 6, fontSize: 11, background: "#dbeafe", color: "#1e40af", padding: "2px 7px", borderRadius: 10, fontWeight: 500 }}>🔗 Vocab</span>}
                </td>
                <td style={{ fontSize: 13, color: "#888" }}>{w.pronunciation || "—"}</td>
                <td style={{ fontSize: 13 }}>{w.meaning}</td>
                <td style={{ textAlign: "center" }}>{w.displayOrder}</td>
                <td style={{ textAlign: "center" }}>{w.isActive ? "✅" : "❌"}</td>
                <td>
                  <button onClick={() => { setEditingWord(w); setShowWordForm(true); }}>Edit</button>
                  <button className="delete-btn" onClick={() => handleDeleteWord(w.id)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );

  // ===== GROUPS LIST VIEW =====
  return (
    <div className="admin-container">
      <div className="admin-header">
        <h2>Similar Words Management</h2>
        <button onClick={() => { setEditingGroup(null); setShowGroupForm(true); }}>+ New Group</button>
      </div>

      {showGroupForm && <WordGroupForm group={editingGroup} onSaved={onGroupSaved} onCancel={() => setShowGroupForm(false)} />}

      <input
        type="text"
        placeholder="Search similar word groups..."
        value={search}
        onChange={(e) => setSearch(e.target.value)}
      />

      {loading ? <p>Loading...</p> : (
        <table className="announcement-table">
          <thead><tr><th>Image</th><th>Title</th><th>Words</th><th>Order</th><th>Active</th><th>Actions</th></tr></thead>
          <tbody>
            {groups.length === 0 ? (<tr><td colSpan="6">No word groups found</td></tr>) : groups.map((g) => (
              <tr key={g.id}>
                <td>
                  {g.imageUrl ? (
                    <img src={toPublicImgSrc(g.imageUrl)} alt="" style={{ width: 44, height: 44, objectFit: "contain", background: "#f5f5f5", borderRadius: 6, border: "1px solid #eee" }} />
                  ) : (
                    <div style={{ width: 44, height: 44, background: "#f5f5f5", borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, color: "#bbb" }}>—</div>
                  )}
                </td>
                <td>
                  <span style={{ color: "#019095", cursor: "pointer", fontWeight: 600 }} onClick={() => openGroupDetail(g)}>{g.title}</span>
                  {g.youtubeVideoLink && <div style={{ fontSize: 12, color: "#666", marginTop: 2 }}>🎥 Has video</div>}
                </td>
                <td style={{ textAlign: "center" }}>{g.wordCount || 0}</td>
                <td style={{ textAlign: "center" }}>{g.displayOrder}</td>
                <td style={{ textAlign: "center" }}>{g.isActive ? "✅" : "❌"}</td>
                <td>
                  <button onClick={() => { setEditingGroup(g); setShowGroupForm(true); }}>Edit</button>
                  <button className="delete-btn" onClick={() => handleDeleteGroup(g.id, g.wordCount || 0)}>Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default AdminSimilarWordsPage;
